import React, { FC } from 'react';
import {
  useDeleteCertificateAdminMutation,
  useDeleteCertificateMutation,
} from '../../hooks/certificate';
import { meState } from '../../plugins/ridge';
import { Button } from '../Button';
import { AnimationLayout } from './AnimationLayout';

interface DeleteCertificateModalProps {
  onClose: () => void;
  open: boolean;
  certificateId: string;
  resumeId: string;
}

export const DeleteCertificateModal: FC<DeleteCertificateModalProps> = ({
  open,
  onClose,
  certificateId,
  resumeId,
}) => {
  const me = meState.useValue();
  if (!me) {
    return <></>;
  }
  const { mutate: deleteCertificateMutate } = useDeleteCertificateMutation(
    resumeId,
    onClose
  );
  const { mutate: deleteCertificateAdminMutate } =
    useDeleteCertificateAdminMutation(resumeId, onClose);
  const _onClick = () => {
    if (me.role === 'ADMIN') {
      deleteCertificateAdminMutate(+certificateId);
    } else {
      deleteCertificateMutate(+certificateId);
    }
  };
  return (
    <>
      <AnimationLayout open={open} onClose={onClose}>
        <div className="my-8 w-full max-w-md transform space-y-3 overflow-hidden rounded-lg bg-white p-6 text-left shadow-xl transition-all">
          <div className="flex justify-between">
            <h4 className="text-gray-800">삭제</h4>
          </div>
          <div className="mt-2">
            <p className="subhead-4 whitespace-pre-line	">
              특기사항을 삭제하시겠습니까?
            </p>
          </div>
          <div className="text-left">
            <Button
              text="삭제하기"
              onClick={_onClick}
              className="mt-4 w-full bg-brand-1 text-white"
            />
          </div>
        </div>
      </AnimationLayout>
    </>
  );
};
